import { render, staticRenderFns } from "./AssistProductTitle.vue?vue&type=template&id=5c1feebd&scoped=true"
import script from "./AssistProductTitle.vue?vue&type=script&lang=js"
export * from "./AssistProductTitle.vue?vue&type=script&lang=js"
import style0 from "./AssistProductTitle.vue?vue&type=style&index=0&id=5c1feebd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1feebd",
  null
  
)

export default component.exports